/**
 * @desc 根据分类编码查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.ProductCategroyModel>>;
export function request(categoryNo: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productCategroy/list/${categoryNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
